import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class RiskWarningIcon extends Field {
  static attributesForModel() {
    return ['riskFactorsCount'];
  }

  get title() {
    return 'Risk warning icon';
  }

  get icon() {
    return 'fa-regular fa-triangle-exclamation';
  }

  exampleContents(): FieldContentsData {
    return {
      icon: { name: this.icon, color: 'var(--theme-alert-danger-text)' },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (!record.riskFactorsCount) return {};

    return {
      icon: { name: this.icon, color: 'var(--theme-alert-danger-text)' },
    };
  }
}
